import { render, staticRenderFns } from "./DeleteLayout.vue?vue&type=template&id=56d7691a"
import script from "./DeleteLayout.vue?vue&type=script&lang=js"
export * from "./DeleteLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports